import * as React from "react";
import { KidsMenu } from "../../components/pageComponents/Menus/KidsMenu";
import Content from "./Shirts";

export default function MensContent() {
  return (
    <>
      <KidsMenu />
      <Content />
    </>
  );
}
